module.exports = __webpack_public_path__ + "static/w-2-e950847832173bae7b734e548e045a1d.svg";